import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/collapse';

// import "bootstrap-sass/assets/javascripts/bootstrap/tab";
// import "bootstrap-sass/assets/javascripts/bootstrap/transition";
// import "bootstrap-sass/assets/javascripts/bootstrap/collapse";

// function isVisible(element) {
//   return $(element).is(':visible');
// }

// function check(iter, el) {
//   var returnValue = false;
//   excludes.forEach((selector) => {
//     if ($(el).is(selector)) {
//       returnValue = true;
//     }
//   })
//   return returnValue;
// }

// const excludes = ['[data-toggle]', '.pagination__item a']

// $('a[href*="#c"]').not(check).on('click', function (event) {
//   const el = window.ScrollManager.validateHash(this.hash)
//   window.ScrollManager.makeEventAndPossiblyScrollTo(el)
// })

// const $tabs = $('.auw_accortabs__tabs');
// const $accordions = $('.auw_accortabs__accordion');

// $(window).on("AuwScrollTo", function (event) {
//   const targetNode = event.detail; // Ziel Element

//   testForTabs(targetNode);
//   testForAccordion(targetNode);
// });

// function testForTabs(targetNode) {
//   $tabs.each(function (key, element) {
//     const $tab = $(element);

//     var [tabs, contents] = $tab.children();

//     $(contents).children().each(function (key, item) {
//       const containsTarget = $.contains(item, targetNode);

//       if (containsTarget) {
//         const targetTabLi = $(tabs).children().get(key);

//         $(targetTabLi).find('a:first').trigger('click');
//       }
//     });
//   })
// }

// function testForAccordion(targetNode) {
//   $accordions.each(function (key, element) {
//     const $accordion = $(element);

//     const $panels = $accordion.find('.panel');

//     $panels.each(function (key, panel) {

//       const [heading, content] = $(panel).children();

//       const containsTarget = $.contains(content, targetNode);

//       if (containsTarget && !isVisible(content)) {
//         $(heading).find('a:first').trigger('click');
//       }
//     });
//   })
// }
